const config = {
  appName: "Pop-up Store",
  languages: ["en", "nl", "de", "es", "fr", "it", "da"],
  locales: [
    "nl-NL",
    "nl-BE",
    "fr-BE",
    "fr-FR",
    "de-DE",
    "es-ES",
    "en-GB",
    "de-AT",
    "it-IT",
    "da-DK",
  ],
  namespaces: [
    "all",
    "common",
    "widget",
    "widget_product",
    "widget_contact",
    "widget_flow_product_request",
    "widget_cart",
    "app",
    "app_embed",
    "app_design",
    "app_catalogue",
    "app_preview",
    "app_products",
    "app_product",
    "app_profile_menu",
    "app_profile",
    "app_file_upload",
    "app_quotes",
    "app_dashboard",
    "app_widgets",
    "app_pricing",
    "app_premium_banner",
    "public",
    "public_signup",
    "public_signin",
    "onboarding_layout",
    "onboarding_welcome",
    "onboarding_business_info",
    "onboarding_usage_preferences",
    "onboarding_domain_settings",
    "onboarding_questionnaire",
    "onboarding_loading",
    "onboarding_completed",
    "campaign_settings",
    "campaign_overview",
    "short_link",
  ],
  appDescription: "Solutions for the print to consumer market.",
  domainName: "popup.print.com",
  featuredCategoryId: "88fdf32d-a886-4562-88b1-ffde16508e37",

  aws: {
    // If you use AWS S3/Cloudfront, put values in here
    bucket: "bucket-name",
    bucketUrl: `https://bucket-name.s3.amazonaws.com/`,
    cdn: "https://cdn-id.cloudfront.net/",
  },
  mailgun: {
    emailDomain: "mail.printupdater.com",
    fromNoReply: `Popup <noreply@printupdater.com>`,
    fromAdmin: `Print Updater <noreply@mail.printupdater.com`,
    supportEmail: "support@mail.printupdater.com.",
    forwardRepliesTo: "chris@converdy.com",
  },
  resend: {
    fromAdmin: "noreply@email.printupdater.com",
  },
  stripe: {
    "nl-NL": {
      plans: [
        {
          title: "Gratis",
          price: "€ 0,-",
          period: "Geen abonnementskosten",
          buttonText: "Kies Gratis",
          priceId: "free",
          name: "free",
          features: {
            description:
              "Maak gebruik van de volledige Pop-up Store functionaliteiten.",
            title: "De functies van Gratis:",
            items: [
              "Kies zelf de producten",
              "Stel verkoopmarge in",
              "Ontvang aanvragen via e-mail",
            ],
          },
        },
        {
          title: "Basis - white label",
          price: "€ 19,-",
          period: "Per maand",
          buttonText: "Kies Basis",
          name: "basic",
          developmentPriceId: "price_1QClTeRtekwavGTpcpJsgYlJ",
          productionPriceId: "price_1Q3HTxRtekwavGTprzG7MIVa",
          isPopular: true,
          features: {
            description:
              "Kies voor meer opties in de vormgeving van de Pop-up Store.",
            title: "Alle functies van Gratis plus:",
            items: [
              "Pas titel van de Pop-up Store aan",
              "Stel eigen icoon in",
              "Gebruik huisstijlkleuren",
            ],
          },
        },
        {
          title: "Premium - white label",
          price: "€ 49,-",
          period: "Per maand",
          buttonText: "Kies Premium",
          name: "premium",
          developmentPriceId: "price_1QClUZRtekwavGTp5LPJLk4a",
          productionPriceId: "price_1Q3HUnRtekwavGTpeq6NnNy8",
          features: {
            description:
              "Geniet van volledige vrijheid in vormgeving en meer functionaliteiten.",
            title: "De functies van Basis plus:",
            items: [
              "Kies eigen productfoto's",
              "Pas namen van producten aan",
              "Maak gebruik van extra opties voor de open-button",
            ],
          },
        },
      ],
      payment_icons: ["ideal", "mastercard", "visa", "bancontact"],
      coupon_banner: {
        enabled: false,
        description:
          "Geniet van 50% korting voor je eerste 3 maanden met code:",
        coupon_validity: "Aanbieding geldig tot eind december 2024.",
        coupon_code: "popup50",
        coupon_id: "popup50",
      },
    },
    "en-GB": {
      plans: [
        {
          title: "Free",
          price: "€ 0,-",
          period: "No subscription costs",
          buttonText: "Choose Free",
          priceId: "free",
          name: "free",
          features: {
            description: "Use all Pop-up Store functionalities.",
            title: "Features of Free:",
            items: [
              "Choose your own products",
              "Set sales margin",
              "Receive requests via email",
            ],
          },
        },
        {
          title: "Basic - white label",
          price: "€ 19,-",
          period: "Per month",
          buttonText: "Choose Basic",
          name: "basic",
          developmentPriceId: "price_1QClTeRtekwavGTpcpJsgYlJ",
          productionPriceId: "price_1Q3HTxRtekwavGTprzG7MIVa",
          isPopular: true,
          features: {
            description:
              "Choose more options in the design of the Pop-up Store.",
            title: "All features of Free plus:",
            items: [
              "Customize Pop-up Store title",
              "Set your own icon",
              "Use brand colors",
            ],
          },
        },
        {
          title: "Premium - white label",
          price: "€ 49,-",
          period: "Per month",
          buttonText: "Choose Premium",
          name: "premium",
          developmentPriceId: "price_1QClUZRtekwavGTp5LPJLk4a",
          productionPriceId: "price_1Q3HUnRtekwavGTpeq6NnNy8",
          features: {
            description:
              "Enjoy complete freedom in design and more functionalities.",
            title: "All features of Basic plus:",
            items: [
              "Choose your own product photos",
              "Customize product names",
              "Use additional options for the open button",
            ],
          },
        },
      ],
      payment_icons: ["mastercard", "visa", "amex"],
      coupon_banner: {
        enabled: false,
        description: "Enjoy a 50% discount for your first 3 months with code:",
        coupon_validity: "Offer valid until the end of December 2024.",
        coupon_code: "popup50",
        coupon_id: "popup50",
      },
    },
    "de-DE": {
      plans: [
        {
          title: "Kostenlos",
          price: "€ 0,-",
          period: "Keine Abonnementkosten",
          buttonText: "Kostenlos wählen",
          priceId: "free",
          name: "free",
          features: {
            description: "Nutzen Sie alle Funktionen des Pop-up Stores.",
            title: "Funktionen von Kostenlos:",
            items: [
              "Wählen Sie Ihre eigenen Produkte",
              "Verkaufsmarge festlegen",
              "Anfragen per E-Mail erhalten",
            ],
          },
        },
        {
          title: "Basis - White Label",
          price: "€ 19,-",
          period: "Pro Monat",
          buttonText: "Basis wählen",
          name: "basic",
          developmentPriceId: "price_1QClTeRtekwavGTpcpJsgYlJ",
          productionPriceId: "price_1Q3HTxRtekwavGTprzG7MIVa",
          isPopular: true,
          features: {
            description:
              "Wählen Sie mehr Optionen für das Design des Pop-up Stores.",
            title: "Alle Funktionen von Kostenlos plus:",
            items: [
              "Passen Sie den Titel des Pop-up Stores an",
              "Eigenes Icon einstellen",
              "Verwenden Sie Markenfarben",
            ],
          },
        },
        {
          title: "Premium - White Label",
          price: "€ 49,-",
          period: "Pro Monat",
          buttonText: "Premium wählen",
          name: "premium",
          developmentPriceId: "price_1QClUZRtekwavGTp5LPJLk4a",
          productionPriceId: "price_1Q3HUnRtekwavGTpeq6NnNy8",
          features: {
            description:
              "Genießen Sie vollständige Freiheit im Design und mehr Funktionen.",
            title: "Alle Funktionen von Basis plus:",
            items: [
              "Wählen Sie eigene Produktfotos",
              "Passen Sie Produktnamen an",
              "Nutzen Sie zusätzliche Optionen für den Öffnen-Button",
            ],
          },
        },
      ],
      payment_icons: ["mastercard", "visa", "sepa"],
      coupon_banner: {
        enabled: true,
        description:
          "Genießen Sie 50% Rabatt für Ihre ersten 3 Monate mit dem Code:",
        coupon_validity: "Angebot gültig bis Ende Dezember 2024.",
        coupon_code: "popup50",
        coupon_id: "popup50",
      },
    },
  },

  auth: {
    registerUrl: "/signup",
    loginUrl: "/signin",
    callbackUrl: "/dashboard",
  },
};

export default config;
